import { RowViewModel } from "./rowViewModel"

export function setupFieldAnalysisHistory(rows: RowViewModel[]) {

    rows = rows.sort((r1, r2) => {

        var diff = 0
        var d1 = r1.getSingleAllocDate()
        var d2 = r2.getSingleAllocDate()

        if (d1 && d2) {
            diff = d2.valueOf() - d1.valueOf()
        }

        return diff

    })

    if (rows.length > 1) {

        var history = rows.slice(1)

        rows[0].fieldHistory = history

        history.forEach(r => {
            r.pastAnalysis = true
            r.hidden = true
        })

    }

    return rows

}
